import { contextType } from "google-map-react";
import React from "react";
import { Reset } from "./Filter";
import { useSearch } from "./SearchContext";

export interface ICountProps {
  className?: string;
  reset?: boolean;
  resetText?: string;
}

export const Count: React.FC<ICountProps> = ({
  className,
  reset = true,
  resetText = "Reset Filters",
}) => {
  const searchContext = useSearch();
  const start = searchContext.perPage
    ? Math.min(
        ((searchContext.page || 1) - 1) * searchContext.perPage,
        searchContext.currentResults.length
      )
    : 0;
  const end = searchContext.perPage
    ? Math.min(
        start + searchContext.perPage,
        searchContext.currentResults.length
      )
    : searchContext.currentResults.length;
  const items = searchContext.currentResults?.slice(start, end);

  return (
    <div className={`search-count ${className}`}>
      {searchContext.currentResults.length > 0 &&
        `Results ${start + 1} to ${end} of ${
          searchContext.currentResults.length
        }`}
      {searchContext.currentResults.length == 0 && "No Results"}
      {reset && (
        <Reset
          text={resetText}
          className="inline-block ml-3 whitespace-nowrap"
        />
      )}
    </div>
  );
};
